import { setupLayouts } from 'virtual:generated-layouts';
import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/pages/Index.vue'),
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/pages/About.vue'),
  },
  {
    path: '/work',
    name: 'Work',
    component: () => import('@/pages/Work.vue'),
  },
  {
    path: '/community',
    name: 'Community',
    component: () => import('@/pages/Community.vue'),
  },
  {
    path: '/principles',
    name: 'Principles',
    component: () => import('@/pages/Principles.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: setupLayouts(routes),
  scrollBehavior (to, from, savedPosition) {
    // If there's a saved position (like back button), use it
    if (savedPosition) {
      return savedPosition;
    }
    // For hash links, scroll to the target element
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      };
    }
    // For regular navigation, scroll to top
    return { top: 0, behavior: 'smooth' };
  },
});

export default router;
